import { withStyles } from 'material-ui';
import { AccountBox, Lock, Visibility, VisibilityOff, Label } from 'material-ui-icons';
import Button from 'material-ui/Button';
import Card, { CardActions, CardContent, CardHeader } from 'material-ui/Card';
import { FormControl, FormHelperText } from 'material-ui/Form';
import IconButton from 'material-ui/IconButton';
import Input, { InputAdornment, InputLabel } from 'material-ui/Input';
import { CircularProgress } from 'material-ui/Progress';
import { trackEvent } from '../../services/gaService';
import React from 'react';
import { translate } from 'react-i18next';
import OLYWebPageComponent from '../OLYWebPageComponent';
import { navigateToFirstAllowedUrl } from '../SideBar/menudataprovider';
import SelectNative from '../../ui/SelectNative';
import { getAccountName } from '../Utils/UserFunctions';
import { login as loginService, loginToken, logout } from './loginService';
const styles = theme => ({
    recoverPassword: theme.palette.recoverPassword
});

class Login extends OLYWebPageComponent {

    constructor() {
        super();
        this.pageName = 'Login';
        this.pageTitle = 'Login';
        this.pageReference = 'https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/689274912/UI+-+Login';
        this.state = {
            user: {
                username: '',
                password: '',
            },
            accountSelection: 'default',
            underTest: (window.location.hostname === 'localhost' || window.location.hostname === 'dev.b2b.olympiaviajes.es' || window.location.hostname === 'qa.b2b.olympiaviajes.es'),
            showPassword: false,
            loading: false,
            failed: false,
            errorInformation: 'LOGIN.WRONG_USER_PASSWORD'
        };

        this.accountName = getAccountName().toLowerCase();
    }


    fieldGenerator = (fieldname) => {
        return {
            onChange: (event) => {
                let user = this.state.user;
                user[fieldname] = event.target.value;
                this.setState({ user });
            },
            value: this.state.user[fieldname]
        };
    };

    login = () => {
        this.setState({ loading: true, failed: false });
        let scope = this;
        loginService(this.state.user)
            .then(response => {
                setTimeout(function () {
                    scope.setState({ loading: false, failed: false });
                    trackEvent('login_success', { username: scope.state.user.username, client: response.user_detail.name});
                    navigateToFirstAllowedUrl();
                }, 1000);
            })
            .catch(err => {
                let msj = this.state.errorInformation;

                if (err.message && err.message.includes('fetch')) {
                    msj = 'Service not available';
                }

                if (err.json) {
                    err.json().then(error => {
                        msj = error.message;
                        this.setState({
                            loading: false,
                            failed: true,
                            errorInformation: msj
                        });
                    });
                } else {
                    this.setState({
                        loading: false,
                        failed: true,
                        errorInformation: msj
                    });
                }
                
                trackEvent('login_fail', { username: scope.state.user.username });
            });
        trackEvent('login_clicked', { username: scope.state.user.username });
    };

    onHashChanged = (hash) => {
        if (hash && hash.query && hash.query.dominio) {
            localStorage.setItem('x-olympia-client', hash.query.dominio);
        }
        if (window.location.href.indexOf('token/') !== -1) {
            console.log('Attemp to recconect from tokenurls');
            console.log(hash);
            logout();
            if (!this.state.loading) {
                console.log('Reconnecting from token');
                trackEvent('login_with_usertoken', { username: this.state.user.username });
                this.setState({ loading: true, failed: false }, () => {
                    loginToken(this.props.match.params.usertoken)
                        .then(response => {
                            this.setState({ loading: false, failed: false });
                            trackEvent('login_with_usertoken_success', { username: this.state.user.username, client: response.user_detail.name });
                            navigateToFirstAllowedUrl(response);
                        })
                        .catch(err => {
                            err.json().then(json => {
                                this.setState({ errorInformation: json.message });
                            });
                            trackEvent('login_with_usertoken_fail', { username: this.state.user.username });
                            this.setState({ loading: false, failed: true });
                        });
                });
            }
        }
    }

    onKeyPress = (e) => {
        if (e.keyCode === 13) {
            this.login();
        }
    };

    render() {
        const { classes, t } = this.props;
        return (

            <div className={'mainbody'}
                style={{ backgroundImage: 'url("../assets/' + String(this.accountName).toLowerCase() + '/fondo-login.png")' }}>
                <img
                    src={`assets/${this.accountName}/logo-login.png`}
                    className={'centered'}
                    alt='logo'
                    style={{ marginTop: '4rem', marginBottom: '1rem', maxWidth: '320px' }}
                />
                <div className={'loginbox'}>
                    <Card>
                        <CardHeader
                            title={t('COMMON.LOGIN')}
                            titlecolor={'blue'}
                            subheader={t('LOGIN.ENTER_USER_PASSWORD')}
                        />
                        <CardContent>
                            <FormControl fullWidth error={this.state.failed}>
                                <InputLabel htmlFor="username">{t('COMMON.USER')}</InputLabel>
                                <Input id="username" {...this.fieldGenerator('username')}
                                    autoFocus={true}
                                    startAdornment={<AccountBox />}
                                    onKeyDown={this.onKeyPress}
                                />
                            </FormControl>
                            <span> </span>
                            <FormControl fullWidth style={{ marginTop: '7px' }} error={this.state.failed}>
                                <InputLabel htmlFor="password">{t('LOGIN.PASSWORD')}</InputLabel>
                                <Input
                                    id="password"
                                    startAdornment={<Lock />}
                                    type={this.state.showPassword ? 'text' : 'password'}
                                    {...this.fieldGenerator('password')}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                                            >
                                                {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    onKeyDown={this.onKeyPress}
                                />
                                {this.state.failed ? <FormHelperText element="p">{t(this.state.errorInformation)}</FormHelperText> : ''}
                            </FormControl>
                            {this.state.underTest ?
                                <FormControl fullWidth style={{ marginTop: '7px' }} error={this.state.failed}>
                                    <cite>Simulate accounts</cite>
                                    <SelectNative
                                        labelProp="name" codeProp="name"
                                        selection={this.state.accountSelection}
                                        promptText="Select account to simulate"
                                        onChange={val => {
                                            this.setState({ accountSelection: val });
                                            localStorage.setItem('x-olympia-client', val);
                                        }}
                                        options={[
                                            { name: 'default' },
                                            { name: 'B2BWebDawson' },
                                            { name: 'B2BWebOlympia' },
                                            { name: 'B2BWebEroski' }
                                        ]}>
                                    </SelectNative>
                                </FormControl>
                                : ''}
                        </CardContent>
                        <CardActions>
                            {
                                this.state.loading ?
                                    <CircularProgress style={{ margin: 'auto' }} />
                                    :
                                    <Button
                                        color="primary"
                                        style={{ width: '100%' }}
                                        onClick={this.login}
                                    >
                                        {t('LOGIN.LOGIN_BUTTON')}
                                    </Button>
                            }
                        </CardActions>
                    </Card>
                    < br />
                    <div style={{ textAlign: 'center' }}>
                        <a className={classes.recoverPassword} href="#/passwordremind">{t('LOGIN.FORGOT_PASSWORD')}</a>
                    </div>
                    < br />
                    < br />
                    <label className='buildVersion'><span className={classes.recoverPassword} style={{ color: '#000' }}>Build: {process.env.REACT_APP_BUILD_VERSION}</span></label>
                </div>
            </div >

        );
    }
}

export default translate('translations')(withStyles(styles)(Login));


// WEBPACK FOOTER //
// ./src/components/Login/Login.js